class LocationX {

  static async GetPosition(options){
    return new Promise((resolve, reject) => 
      navigator?.geolocation?.getCurrentPosition(resolve, reject, options)
    );
  }

}

export default LocationX;